import { Inject, Injectable } from '@angular/core'
import { CoreService } from './core.service'
import { DOCUMENT } from '@angular/common'
import { interval, Subscription } from 'rxjs'

@Injectable()
export class ScrollService {
  private key: any
  private subscriptions = new Subscription()

  constructor(
    private core: CoreService,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  setKey(key: any) {
    this.key = key
  }

  save(name, value) {
    const settings = this.core.services.storage.getSync(this.key)
    const result = value || settings[name]
    // vaclave, ty mastaku. facepalmuju tady mocne, jako.. ulozime celou app do localu, wtf not! oh, maybe protoze na seznamy hoven neni v localu misto..? fakin hell
    // console.log('save scrl serv', result, name, value, { ...settings, [name]: result })
    try {
      this.core.services.storage.set(this.key, { ...settings, [name]: result })
    } catch (e) {
      console.log('localStorage quota exceeded in scriollService. key:', name)
    }
  }

  getValue(): any {
    return this.core.services.storage.getSync(this.key)
  }

  clearValue(key, name) {
    const settings = this.core.services.storage.getSync(key)
    const nextSettings = { ...settings }
    delete nextSettings[name]
    this.core.services.storage.set(key, { ...nextSettings })
  }

  scrollTo(elementId: string) {
    this.subscriptions.add(
      interval(50).subscribe(() => {
        const el = this.document.getElementById(elementId)
        if (el) {
          el.scrollIntoView({ behavior: 'auto', block: 'start', inline: 'center' })
          this.subscriptions.unsubscribe()
        }
      }),
    )
  }
}
